import { useEffect, useState } from "react";
import { BODY_MARKER_ATTRIBUTE } from "../tokenInjector/ThemeMarkerAttribute";
const getThemeKey = fallback => document.body.getAttribute(BODY_MARKER_ATTRIBUTE) ?? fallback;
/**
 * This hook returns the current theme's key or null if none is present.
 */
export const useThemeKey = function () {
  let {
    fallbackTheme = "lodestar-light",
    isDisabled
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [themeKey, setThemeKey] = useState(() => getThemeKey(fallbackTheme));

  // Hooks up a MutationObserver that watches the body class. This means any change
  // to add/remove the class we care about will cause a re-render here.
  // This is good because many components could use this hook and we want them all
  // to pay attention.
  useEffect(() => {
    if (isDisabled) {
      return;
    }
    // Do a quick update in case it has changed while we were disabled.
    setThemeKey(getThemeKey(fallbackTheme));
    const obs = new MutationObserver(() => setThemeKey(getThemeKey(fallbackTheme)));
    obs.observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_MARKER_ATTRIBUTE]
    });
    return () => {
      obs.disconnect();
    };
  }, [isDisabled, fallbackTheme]);
  return {
    themeKey
  };
};
//# sourceMappingURL=useThemeKey.js.map